import styled from 'styled-components';

import { space, SpaceProps } from 'styled-system';
import { themeGet } from '../../theme/utils';

const ContentContainer = styled.div<SpaceProps>`
  ${space}
  margin: 0 auto;
  width: 100%;
  max-width: ${themeGet.content('maxWidth')};
`;

ContentContainer.defaultProps = {
  m: 0,
  pl: 0,
  pr: 0,
};

export { ContentContainer };
